module.exports = __webpack_public_path__ + "2df5440ba249c47f0ed75423ea3fc1ed.svg";